import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-basketball-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">乐鱼体育</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              乐鱼体育资讯中心 — 汇聚全球最新体育新闻、赛事直播资讯、运动员动态及赛程安排，为您提供权威、及时、全面的体育内容。
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer text-background-300 hover:text-background-50">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer text-background-300 hover:text-background-50">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer text-background-300 hover:text-background-50">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors cursor-pointer text-background-300 hover:text-background-50">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">资讯分类</h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-100 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门赛事</h4>
            <ul className="space-y-2.5">
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">世界杯预选赛</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">NBA新赛季</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">英雄联盟S16</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">法网公开赛</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">F1大奖赛</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">关于我们</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">品牌介绍</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">加入我们</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">广告合作</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-background-100 transition-colors">用户协议</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 乐鱼体育资讯中心 版权所有 | 京ICP备2022000001号
          </p>
          <p className="text-xs text-background-500">
            体育资讯，尽在乐鱼
          </p>
        </div>
      </div>
    </footer>
  );
}